export default "__VITE_ASSET__yUULLh5E__"